import { FC } from "react";

import { formatDateTime } from "@testavivadk/utilities";

import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

import { brandColorTokens } from "@constants";

import { INotificationItemProperties } from "./NotificationItem.types";

const NotificationItem: FC<INotificationItemProperties> = ({ notification, onOpen }) => (
  <MenuItem
    onClick={() => onOpen(notification)}
    data-cy="notification-item"
    data-cy-unread={!notification.is_read}
    sx={[
      { alignItems: "flex-start", gap: 1.5, px: 2, py: 1.5, whiteSpace: "normal" },
      !notification.is_read && { bgcolor: brandColorTokens.background.quaternary },
    ]}
  >
    <Box
      sx={{
        flexShrink: 0,
        width: 8,
        height: 8,
        mt: 0.75,
        borderRadius: "50%",
        bgcolor: notification.is_read ? "transparent" : "secondary.main",
      }}
    />
    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, minWidth: 0 }}>
      <Box
        sx={{
          display: "-webkit-box",
          overflow: "hidden",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",
          typography: "body2",
          color: "text.primary",
          "& p": { m: 0 },
        }}
        dangerouslySetInnerHTML={{ __html: notification.content }}
      />
      <Typography variant="caption" color="text.secondary">
        {formatDateTime({ date: notification.timestamp })}
      </Typography>
    </Box>
  </MenuItem>
);

export default NotificationItem;
